import {
    colsConfig_query,
    colsConfig_update,
    colsConfig_updateToDefault
} from '@/api/sysConfig/index.js'
import _ from 'lodash'

/**
 * 查询列配置
 * @param {*} pageId 
 * @returns 
 */
export async function getColsConfig(pageId) {
    const res = await colsConfig_query({pageId})
    if (res.result === 1 && res.data) {
        return res.data.list;
    } else {
        return [];
    }
}

/**
 * 更新列配置
 * @param {*} params 
 * @returns 
 */
export async function updateColsConfig(params, options = {}) {
    // 需要移除colId
    let _params = _.cloneDeep(params)
    if (_params.list) {
        _params.list = _params.list.map(item => {
            delete item.colId
            return item;
        })
    }
    const res = await colsConfig_update(_params, options)
    return res.result === 1

}

/**
 * 还原成默认配置
 * @param {*} pageId 
 * @returns 
 */
export async function toDefaultColsConfig(pageId) {
    const res = await colsConfig_updateToDefault({pageId})
    if (res.result === 1 && res.data) {
        return res.data.list
    } else {
        return []
    }
}